import React, { useState, useRef, useEffect } from 'react';
import './About-inbrija.css';
import Header from '../../Header/header';
import HeaderMenu from '../../Header/header-menu';
import Footer from '../../Footer/Footer';
import Isi from '../../ISI/Isi';
import IsiFrame from '../../ISI/Isi-frame';
import NavigationBar from '../../NavigationBar/NavigationBar';
import AboutInbrijaModal from '../About-Inbrija-Modal'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import moment from 'moment'
import MainLayout from '../../Layouts/Main_Layout';
import { Datepicker } from 'vanillajs-datepicker';
import 'vanillajs-datepicker/css/datepicker-bs5.css';

export default function AboutInbrija() {
  const myRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  
  const [show, setShow] = useState(true);
  const [inb, setInb] = useState(false);
  const [talk, setTalk] = useState(false);
  const [startedModal, setStartedModal] = useState(false);
  const [ans1, setAns1] = useState('');
  const TalkDr = useRef(null)
  const location = useLocation();
  const navigate = useNavigate();
  const url = process.env.REACT_APP_API_URL;
  const [anonId, setAnonId] = useState("");
  const [emailInput, setEmail] = useState("");
  const [selectedData, setSelectedData] = useState('');
  const [selectedDataAns3, setSelectedDataAns3] = useState('');
  const [secondAnswers, setSecondAnswers] = useState('')
  const [thirdAnswer, setThirdAnswer] = useState('')
  const firstAnswer = 'A1' + ":" + ans1

  const executeScroll = () => {
    var element = myRef.current;
    var headerOffset = 100;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    if (getChromeVersion() > 60) {
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    else {
      window.scrollTo(0, offsetPosition);
    }
    setShow(true)
  }

  const ValidateInputEmail = (inputName) => {
    var validRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;;
    var email = document.getElementById('sendEmail');
    if (email.value.match(validRegex)) {
      email.classList.remove('error');
      document.getElementById('sendEmailError').classList.remove('error');
      document.getElementById('sendEmailError').innerHTML = '*Required';
    }
    else {
      document.getElementById('sendEmailError').classList.add('error');
      document.getElementById('sendEmailError').innerHTML = '*You must enter a valid email address';
    }
  };

  const GoTo = (last_step, next_step) => {
    var errorFlag = 0;
    var ifChecked = 0;
    var fields = document.querySelectorAll('input.radio-css');
    if (last_step === 'step4-ddg' && next_step === 'step1-ddg') {
      errorFlag = 0;
      fields.forEach(field => {
        field.checked = false;
      })
    }
    if (last_step === 'step1-ddg' && next_step === 'step2-ddg') {
      ifChecked = 0;
      fields = document.querySelectorAll('input.radio-css');
      fields.forEach(field => {
        if (field.checked) {
          ifChecked = 1
        }
      })
      if (ifChecked === 0) {
        errorFlag = 1;
        fields.forEach(field => {
          field.classList.add('error');
        })
      }
    }
    if (last_step === 'step2-ddg' && next_step === 'step3-ddg') {
      ifChecked = 0;
      fields = document.querySelectorAll('input.step2-ddg-fields');
      fields.forEach(field => {
        if (field.checked) {
          ifChecked = 1
        }

      })
      if (ifChecked === 0) {
        errorFlag = 1;
        fields.forEach(field => {
          field.classList.add('error');
        })
      }
    }
    else if ((last_step === 'step3-ddg' && next_step === 'step4-ddg') || (last_step === 'step3-ddg' && next_step === 'step4-ddg-mobile')) {
      ifChecked = 0;
      fields = document.querySelectorAll('input.step3-ddg-fields');
      fields.forEach(field => {
        if (field.checked) {
          ifChecked = 1
        }

      })
      if (ifChecked === 0) {
        errorFlag = 1;
        fields.forEach(field => {
          field.classList.add('error');
        })
      }
    }
    else if ((last_step === 'step5-ddg' && next_step === 'step6-ddg') || (last_step === 'step5-ddg-mobile' && next_step === 'step6-ddg-mobile')) {
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      var email = document.getElementById('sendEmail');
      if (!email.value.match(validRegex)) {
        errorFlag = 1;
        email.classList.add('error');
        document.getElementById('sendEmailError').classList.add('error');
        document.getElementById('sendEmailError').innerHTML = '*You must enter a valid email address';
      }
    }
    else if (last_step === 'step6-ddg-mobile' && next_step === 'step1-ddg') {
      document.getElementById('step4-ddg').classList.add('d-none')
    }
    if (errorFlag === 0) {
      if (document.getElementById(last_step).innerHTML.length > 1) {
        document.getElementById(last_step).classList.add('d-none');
      }
      if (document.getElementById(next_step).innerHTML.length > 1) {
        document.getElementById(next_step).classList.remove('d-none');
      }
    }
    return;
  }

  const [imagesLoaded, setImagesLoaded] = useState(false);

  const handleImageLoads = () => {
    // Check if all images have finished loading
    const allImagesLoaded = Array.from(document.querySelectorAll('img')).every((image) => image.complete);

    if (allImagesLoaded) {
      setImagesLoaded(true);
    }
  };

  const [videosLoaded, setVideosLoaded] = useState(false);

  function handleAboutCSS() {
    if (document.getElementById('about-inbrija-page')) {
      var element = document.getElementById('talkDr');
      if(element !== null) {
        var offsetTop1 = element.offsetTop - 100;
        if (window.scrollY > offsetTop1) {
          document.getElementById('talk-link').classList.add('submenu-style-active');
        }
        else {
          document.getElementById('talk-link').classList.remove('submenu-style-active');
          document.getElementById('talk-link').classList.add('submenu-style-not-active');
        }
      }
      var element2 = document.getElementById('whatinbrija');
      if(element2 !== null) {
        var offsetTop2 = element2.offsetTop - 100;
        if (window.scrollY > offsetTop2) {
          document.getElementById('inbrija-menu-link').classList.add('submenu-style-active');
        }
        if (window.scrollY > offsetTop1 || window.scrollY < offsetTop2) {
          document.getElementById('inbrija-menu-link').classList.remove('submenu-style-active');
          document.getElementById('inbrija-menu-link').classList.add('submenu-style-not-active');
        }
      }
    }
  }

  const handleVideoClick = (clickClass) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag('event', 'patient_video', {
        'event_category': 'video_start',
        'event_label': clickClass,
        'page_location': window.location.href
      });
    }
  }

  const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (raw) {
      return parseInt(raw[2], 10);
    }
    else {
      return 100;
    }
  }

  useEffect(() => {
    setTimeout(() => {
      let el = document.querySelector('.inbrija-anywhere-video-section');
      if (el) {
        const video = el.querySelector('video');
        if(video !== null) {
          const videoButton = document.querySelector(".video-container .play-button")
          video.muted = true;
          if(videoButton) {
            videoButton.click();
          }
        }
      }
    }, 150);
    document.addEventListener('click', function (e) {
      if (e.target.closest('a') || e.target.closest('button')) {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          if (document.location.pathname.includes('/what-are-off-periods')) {
            window.gtag('event', 'what_are_off_periods_buttons');
          }
          if (document.location.pathname.includes('/about-inbrija')) {
            window.gtag('event', 'about_inbrija_buttons');
          }
          if (document.location.pathname.includes('/how-to-use-inbrija')) {
            window.gtag('event', 'how_to_use_inbrija_buttons');
          }
          if (document.location.pathname.includes('/savings-and-support')) {
            window.gtag('event', 'savings_and_support_buttons');
          }
        }
      }
    });

    handleAboutCSS();

    var element = null;
    var elementPosition = 0;
    var headerOffset = 40;
    var offsetPosition = 0;
    if (location.hash === '#what-is-inbrija') {
      element = document.getElementById('whatinbrija');
      headerOffset = 40;
      elementPosition = element.getBoundingClientRect().top;
      offsetPosition = elementPosition + window.pageYOffset - headerOffset
      if (getChromeVersion() > 60) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
      else {
        window.scrollTo(0, offsetPosition);
      }
      setInb(true);
      setTalk(false)
    }

    if (location.hash === '#talking-with-doctor') {
      element = document.getElementById('talkDr');
      elementPosition = element.getBoundingClientRect().top;
      offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      if (getChromeVersion() > 60) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
      else {
        window.scrollTo(0, offsetPosition);
      }
      setInb(false);
      setTalk(true)
    }

    setTimeout(() => {
      if (location.hash === '#full-ISI') {
        element = myRef.current;
        headerOffset = 39;
        elementPosition = element.getBoundingClientRect().top;
        offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        if (getChromeVersion() > 60) {
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
        else {
          window.scrollTo(0, offsetPosition);
        }
      }
    }, 1000);

    if (location.pathname === '/about-inbrija' || location.pathname === '/about-inbrija/') {
      var windowHeight = window.innerHeight;
      var header = document.getElementById('submenu');

      window.addEventListener('scroll', function () {
        var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollPosition > windowHeight) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      });
    }

    const handleHashChange = () => {
      // Reset the images loaded status
      setImagesLoaded(false);
    };

    window.addEventListener('hashchange', handleHashChange);

    const videoElements = document.querySelectorAll('video');

    const handleVideoLoaded = () => {
      const allVideosLoaded = Array.from(videoElements).every(video => video.readyState >= 4);
      if (allVideosLoaded) {
        setVideosLoaded(true);
      }
    };

    const handleVideoError = () => {
    };

    videoElements.forEach(video => {
      video.addEventListener('loadeddata', handleVideoLoaded);
      video.addEventListener('error', handleVideoError);
    });

    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef !== null && componentElement !== null) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("scroll", handleAboutCSS);

        return () => {
          window.removeEventListener("scroll", handleScroll);
          window.removeEventListener("scroll", handleAboutCSS);
        };
      }
    };

    calculateOffset();
    window.addEventListener('resize', calculateOffset);

    const getCookieValue = (cookieName) => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(cookieName + '='))
        ?.split('=')[1];
      return cookieValue;
    };
    const anonID = getCookieValue('Anon_ID');
    setAnonId(anonID)

    return () => {
      window.removeEventListener('resize', calculateOffset);
      window.removeEventListener('hashchange', handleHashChange);
      videoElements.forEach(video => {
        video.removeEventListener('loadeddata', handleVideoLoaded);
        video.removeEventListener('error', handleVideoError);
      });
    };
  }, [location, imagesLoaded, videosLoaded])

  if (imagesLoaded) {
    var header = document.getElementById('submenu');

    window.addEventListener('scroll', function () {
      var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = header.offsetTop;
      if (scrollPosition > offsetTop) {
        header.classList.add('sticky');
      } else {
        header.classList.remove('sticky');
      }
    });
  }

  const [dateInput, setDateInput] = useState('')
  const HandleChangeDate = (e) => {
    console.log(e)
    document.getElementById("myDateInput").value = e;
    var responseDate = moment(document.getElementById("myDateInput").value).format('MM/DD/YYYY');
    document.getElementById("myDateInput").value = responseDate;
  }

  const HandleChangeDateMobile = (e) => {
    document.getElementById("myDateInputinput").value = e;
    var responseDate = moment(document.getElementById("myDateInputinput").value).format('MM/DD/YYYY');
    document.getElementById("myDateInputinput").value = responseDate;
    setDateInput(responseDate);
  }

  const handlePdfDownloadDDG = () => {
    var ddg_file = '/pdfs/doctor-discussion-guide-customized.pdf';
    var answer1 = ans1;
    var answer2 = selectedData
    var answer3 = selectedDataAns3
    var date = dateInput;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');
    myUrlWithParams.searchParams.append('file', ddg_file);
    myUrlWithParams.searchParams.append('answer1', answer1);
    myUrlWithParams.searchParams.append('answer2', answer2);
    myUrlWithParams.searchParams.append('answer3', answer3);

    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }

    fetch(`${url}/signup`, {
      method: 'POST',
      body: JSON.stringify({
        "source_name": "inbrija_pwp_ddg_download",
        "visitor_id": "00000000-0000-0000-0000-000000000000",
        "qn_hibbert_id": "",
        "qn_pdf_url": myUrlWithParams,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
    })
    window.open(myUrlWithParams);
  }

  const handlePdf = (e) => {
    e.preventDefault();
    var ddg_file = '/pdfs/doctor-discussion-guide-customized.pdf';
    var answer1 = ans1;
    var answer2 = selectedData
    var answer3 = selectedDataAns3
    var date = dateInput;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');
    myUrlWithParams.searchParams.append('file', ddg_file);
    myUrlWithParams.searchParams.append('answer1', answer1);
    myUrlWithParams.searchParams.append('answer2', answer2);
    myUrlWithParams.searchParams.append('answer3', answer3);
    myUrlWithParams.searchParams.append('date', date);
    myUrlWithParams.searchParams.append('utm_source', 'inbrija');
    myUrlWithParams.searchParams.append('utm_medium', 'email');
    myUrlWithParams.searchParams.append('utm_campaign', 'em13368ddgltr');
    myUrlWithParams.searchParams.append('utm_content', 'get guide');
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }

    const myUrlWithParamsNow = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');
    myUrlWithParamsNow.searchParams.append('file', ddg_file);
    myUrlWithParamsNow.searchParams.append('answer1', answer1);
    myUrlWithParamsNow.searchParams.append('answer2', answer2);
    myUrlWithParamsNow.searchParams.append('answer3', answer3);
    myUrlWithParamsNow.searchParams.append('date', date);
    myUrlWithParamsNow.searchParams.append('utm_source', 'inbrija');
    myUrlWithParamsNow.searchParams.append('utm_medium', 'email');
    myUrlWithParamsNow.searchParams.append('utm_campaign', 'em13368ddg');
    myUrlWithParamsNow.searchParams.append('utm_content', 'get guide');
    if (urlParams.get('utm_campaign')) {
      myUrlWithParamsNow.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParamsNow.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParamsNow.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParamsNow.searchParams.append('utm_content', urlParams.get('utm_content'));
    }

    fetch(`${url}/signup`, {
      method: 'POST',
      body: JSON.stringify({
        "source_name": "inbrija_pwp_ddg_email",
        "visitor_id": "00000000-0000-0000-0000-000000000000",
        "qn_hibbert_id": "",
        "email": emailInput,
        "qn_appointment_date": document.getElementById('myDateInput').value,
        // "qn_answer": allAnswers,
        "qn_pdf_url": myUrlWithParams,
        "qn_now_pdf_url": myUrlWithParamsNow,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag('event', 'ddg_emailed', {
          'event_category': 'form_submit',
          'event_label': 'about_savings_program_footer',
          'page_location': window.location.href
        });
      }
    })
  }

  const handlePdfMobile = (e) => {
    e.preventDefault();
    var ddg_file = '/pdfs/doctor-discussion-guide-customized.pdf';
    var answer1 = ans1;
    var answer2 = selectedData
    var answer3 = selectedDataAns3
    var date = dateInput;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');
    myUrlWithParams.searchParams.append('file', ddg_file);
    myUrlWithParams.searchParams.append('answer1', answer1);
    myUrlWithParams.searchParams.append('answer2', answer2);
    myUrlWithParams.searchParams.append('answer3', answer3);
    myUrlWithParams.searchParams.append('date', date);
    myUrlWithParams.searchParams.append('utm_source', 'inbrija');
    myUrlWithParams.searchParams.append('utm_medium', 'email');
    myUrlWithParams.searchParams.append('utm_campaign', 'em13368ddgltr');
    myUrlWithParams.searchParams.append('utm_content', 'get guide');
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }

    const myUrlWithParamsNow = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');
    myUrlWithParamsNow.searchParams.append('file', ddg_file);
    myUrlWithParamsNow.searchParams.append('answer1', answer1);
    myUrlWithParamsNow.searchParams.append('answer2', answer2);
    myUrlWithParamsNow.searchParams.append('answer3', answer3);
    myUrlWithParamsNow.searchParams.append('date', date);
    myUrlWithParamsNow.searchParams.append('utm_source', 'inbrija');
    myUrlWithParamsNow.searchParams.append('utm_medium', 'email');
    myUrlWithParamsNow.searchParams.append('utm_campaign', 'em13368ddg');
    myUrlWithParamsNow.searchParams.append('utm_content', 'get guide');
    if (urlParams.get('utm_campaign')) {
      myUrlWithParamsNow.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParamsNow.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParamsNow.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParamsNow.searchParams.append('utm_content', urlParams.get('utm_content'));
    }

    fetch(`${url}/signup`, {
      method: 'POST',
      body: JSON.stringify({
        "source_name": "inbrija_pwp_ddg_email",
        "visitor_id": "00000000-0000-0000-0000-000000000000",
        "qn_hibbert_id": "",
        "email": emailInput,
        "qn_appointment_date": document.getElementById('myDateInputinput').value,
        "qn_pdf_url": myUrlWithParams,
        "qn_now_pdf_url": myUrlWithParamsNow,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag('event', 'ddg_emailed', {
          'event_category': 'form_submit',
          'event_label': 'about_savings_program_footer',
          'page_location': window.location.href
        });
      }
    })
  }

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };
  
  const handleDownloadBothApi = () => {
    if (showEle) {
      var ddg_file = '/pdfs/doctor-discussion-guide.pdf';
    }
    else {
      var ddg_file = '/pdfs/doctor-discussion-guide-customized.pdf';
    }

    var answer1 = ans1;
    var answer2 = selectedData
    var answer3 = selectedDataAns3
    var date = dateInput;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('answer1', answer1);
    myUrlWithParams.searchParams.append('answer2', answer2);
    myUrlWithParams.searchParams.append('answer3', answer3);

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    fetch(`${url}/signup`, {
      method: 'POST',
      body: JSON.stringify({
        "source_name": "inbrija_pwp_ddg_download",
        "visitor_id": "00000000-0000-0000-0000-000000000000",
        "qn_hibbert_id": "",
        "qn_pdf_url": myUrlWithParams,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((data) => {
    })
    window.open(myUrlWithParams);
  }

  const handleDownloadDdgBlank = () => {
    var ddg_file = 'doctor-discussion-guide.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = 'guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handlePatientIfuPdf = () => {
    var ddg_file = 'inbrija-patient-info-IFU.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = 'guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handleInstPdf = () => {
    var ddg_file = 'inbrija-instructions-for-use.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      ddg_file = 'guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + '/pdf-resources');

    myUrlWithParams.searchParams.append('file', ddg_file);
    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const MobileThanku = () => {
    setStartedModal(true);
  }

  const MobileDatePicker = () => {
    const elem1 = document.getElementById('myDateInputinput');
    const datepicker = new Datepicker(elem1, { buttonClass: 'btn', autohide: true });
  }

  const handleQuesTracking = (clickCategory, clickClass) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag('event', 'ddg_survey', {
        'event_category': clickCategory,
        'event_label': clickClass,
        'page_location': window.location.href
      });
    }
  }

  const [showEle, setShowEle] = useState(false)

  const BlankDDGMailModal = () => {
    setStartedModal(true);
    setShowEle(true)
  }

  var boolDisableClick = (getChromeVersion() < 60) ? "disable-link-click" : "";

  return (
    <MainLayout>
      <div className='about-inbrija' id="about-inbrija-page">
        <Helmet>
          <title>Learn About INBRIJA® | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`Learn About INBRIJA® | INBRIJA® (levodopa inhalation powder)`} />
          <meta property='og:description' content={`Learn about INBRIJA, a prescription medicine that is levodopa for inhalation.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta name='description' content={`Learn about INBRIJA, a prescription medicine that is levodopa for inhalation.`} />
          <meta property='og:type' content='website' />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/about-inbrija' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <div>
          <HeaderMenu>
            <div className="container-1500">
              <div className='hero-section'>
                <div className='hero-section-image show_desktop'>
                  <img onLoad={handleImageLoads} src="/assets/images/about-inbrija-hero.webp" className='img-fluid' alt={`A man dressed in a hoodie punches towards the camera. The text on his hood reads "What if the shaking comes back? I'll fight it."`} />
                  <div className="actor_portrayal">Actor portrayal.</div>
                </div>
                <div className='hero-section-content'>
                  <h1>On-demand treatment that <span>helps you fight back</span></h1>
                  <div className='show_mobile'>
                    <img onLoad={handleImageLoads} src="/assets/website_images/about-inbrija-hero-mobile.webp" className='img-fluid' alt={`A man dressed in a hoodie punches towards the camera. The text on his hood reads "What if the shaking comes back? I'll fight it."`} />
                    <div className="actor_portrayal">Actor portrayal.</div>
                  </div>
                  <h4><img onLoad={handleImageLoads} src="/assets/images/inbrija-about-inhaler-about.webp" alt="10 minute timer" />
                    <span>10 minutes could make the difference between losing your moments to symptom return and fighting to get back to them.</span>
                  </h4>
                </div>
              </div>
            </div>
          </HeaderMenu>
        </div>
        <div className="menu-bar-sticky-desktop">
          <div className="brush-style-2" id="submenu">
            <div className="submenu-style">
              <Link className='text-decoration-none' to="/about-inbrija#what-is-inbrija"> <div id="inbrija-menu-link" className={inb ? 'submenu-style-active' : 'submenu-style-not-active'}>What Is INBRIJA?</div></Link>
              <Link className='text-decoration-none' to="/about-inbrija#talking-with-doctor"> <div id="talk-link" className={talk ? 'submenu-style-active' : 'submenu-style-not-active'} >Talking With Your Doctor</div></Link>
            </div>
          </div>
        </div>
        <div className='menu-bar-sticky-mobile'>
          <div className="brush-style-2 mobile-header-sticky">
          </div>
        </div>
        <div className='about-inbrija-intro-section' id='whatinbrija'>
          <h3 className=''>INBRIJA, the on-demand inhaled levodopa,<br className='br-inhaler' /> may start to work in as little as <b>10 minutes</b></h3>
          <p>For people taking carbidopa/levodopa for Parkinson's disease (PD) and experiencing <br className='br-inhaler' /> the return of symptoms between regular doses of medication, adding INBRIJA can help.</p>
          <p>In a large clinical trial, INBRIJA started improving motor symptoms <b>in as early as 10 minutes</b> <br className='br-inhaler' />
            and significant relief in motor symptoms was seen in 30 minutes of taking INBRIJA.</p>
        </div>

        <div className='about-inbrija-rescue-section' id="rescue-section">
          <div className='container'>
            <div className='about-inbrija-rescue-section-left'>
              <h3><b>Rescue the moments</b> in your day with INBRIJA</h3>
              <p>INBRIJA is an inhaled form of the levodopa in your regular carbidopa/levodopa PD medication. INBRIJA does not replace your regular carbidopa/levodopa medicine.</p>
            </div>
            <div className='about-inbrija-rescue-section-right' onLoad={handleImageLoads}>
              <div className='about-inbrija-rescue-section-right-splash'>
                <h3>You can use INBRIJA as needed* to fight Parkinson's symptoms when they return.</h3>
                <p>*1 dose (2 capsules) per OFF <br /> period up to 5 times per day.</p>
              </div>
            </div>
          </div>
        </div>

        <div className='inbrija-anywhere-section center'>
            <div className='inbrija-anywhere-section-container'>
                <div className='inbrija-anywhere-section-container-left'>
                    <h3 className='show_desktop'>Jimmy uses INBRIJA <span> where</span><br className='br-desktop' />he wants to use it...</h3>
                    <h3 className='show_mobile'>Jimmy uses INBRIJA <span> where</span> he wants to use it...</h3>
                    <p><img src="/assets/images/comma-yellow-mobile.webp" alt='comma' onLoad={handleImageLoads} /> I&rsquo;ve been using it a couple of years now and I&rsquo;ll do it in front of anybody, in a restaurant or anywhere. And it&rsquo;s allowed me to have Parkinson&rsquo;s and still be able to go out&hellip; <img className="" onLoad={handleImageLoads} alt='comma' src="/assets/images/comma-yellow-close-mobile.webp" /> </p>
                    <p>—Jimmy, person with Parkinson's</p>
                    <h6>Please see <a href="https://dailymed.nlm.nih.gov/dailymed/getFile.cfm?setid=a906f8e1-6e1c-480a-8276-c01bc65dd3be&type=pdf" target="_blank" rel="noopener">Full Prescribing Information</a></h6>
                </div>
                <div className='inbrija-anywhere-section-container-right'>
                    <figure>
                        <img onLoad={handleImageLoads} src="/assets/website_images/FTF_BOXING.webp" className='img-fluid hand-image' alt={`Clenched fist with boxing gloves. Text on boxing gloves reads "I choose to fight".`} />
                        <figcaption>
                            Actor portrayal.
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>

        <div className='inbrija-anywhere-video-section'>
            <div className="video-container">
              <video ref={videoRef} muted loop playsInline controls={isPlaying} className="img-fluid w-full"
                poster="/assets/images/jimmy-video-poster.webp"
                title="Side by side view of Jimmy, a person with Parkinson's, before and after using INBRIJA.">
                <source src="/videos/hero-jimmy_cmp.mp4" type="video/mp4" />
              </video>
              {!isPlaying && (
                <button onClick={handlePlayClick} aria-label="Play video">
                  <img src="/assets/images/play-video-button.webp" alt="Play Button" className="play-button" />
                </button>
              )}
            </div>
            <div className='video-buttons'>
                <a href="/how-to-use-inbrija" className='how-to-use-button' id='about_learn_how_use'>
                    How to Use INBRIJA
                </a>
                <a href="/patient-videos#watch-jimmy-patient-video" className='play-jimmy-video' onClick={() => { handleVideoClick('about_watch_jimmy') }}>
                    Watch Jimmy's Story
                </a>
            </div>
        </div>

        <div className='inbrija-return-section'>
          <div className='inbrija-return-section-container'>
            <h3>INBRIJA can help you manage the return of your symptoms</h3>
            <p>INBRIJA is used <b>in addition to</b> your usual Parkinson's medications. It may start to work in as<br className='br-desktop' /> little as 10 minutes. In a large study, significant relief in motor symptoms was seen in<br className='br-desktop' /> 30 minutes of taking INBRIJA.</p>
          </div>
        </div>

        <div className='inbrija-orally-inhaled-section container'>
          <div className='inbrija-orally-inhaled-section-top'>
            <div className='inbrija-orally-inhaled-section-top-image'>
              <svg width="101" height="101" viewBox="0 0 101 101" fill="none" xmlns="http://www.w3.org/2000/svg" onLoad={handleImageLoads}>
                <title>Inhale orally</title>
                <circle cx="50.5" cy="50.5" r="49" fill="white" stroke="#4B3F67" strokeWidth="3" />
                <g clipPath="url(#clip0_201_10052)">
                  <path d="M52.1786 16.542C38.952 16.5706 28.1562 27.2806 28.0561 40.5501L21.6216 47.0418C21.5215 47.1276 21.307 47.3135 21.0353 47.5423C19.0049 49.2153 18.4186 49.7301 18.4043 50.731C18.4758 53.6051 20.1059 54.0341 20.8065 54.077L25.5538 54.7633V66.9604C25.5538 69.906 27.9704 72.3082 30.916 72.3225H40.5678V79.472C40.5678 80.3586 41.2971 81.0735 42.1836 81.0735C43.0701 81.0735 43.7851 80.3586 43.7851 79.472V71.9651C43.7851 71.2072 43.4848 70.478 42.9557 69.9489C42.4124 69.4055 41.6974 69.1052 40.9253 69.1052H30.916C29.7291 69.1052 28.7711 68.1329 28.7711 66.9604V61.0692H51.7353C51.7353 61.0692 51.8211 61.0692 51.8783 61.0692C53.6228 60.9262 54.9955 59.4677 54.9955 57.6946C54.9955 55.8214 53.4798 54.3057 51.6067 54.3057C49.7335 54.3057 48.2178 55.8214 48.2178 57.6946C48.2178 58.1665 48.6039 58.5526 49.0757 58.5526C49.5476 58.5526 49.9337 58.1665 49.9337 57.6946C49.9337 56.7795 50.6772 56.0216 51.6067 56.0216C52.5361 56.0216 53.2796 56.7652 53.2796 57.6946C53.2796 58.6241 52.5361 59.3676 51.6067 59.3676H28.7711V54.4773C28.7711 53.7052 28.4708 52.9902 27.9418 52.4612C27.4413 51.9464 26.7692 51.6461 26.0543 51.6175L21.9219 51.017C22.3079 50.6738 22.8084 50.2734 23.0801 50.0446C23.4805 49.7158 23.8093 49.4441 23.8951 49.344L30.4441 42.7378C30.9731 42.2088 31.2734 41.4795 31.2591 40.6359C31.2877 29.1537 40.6679 19.8022 52.1786 19.7879C63.6893 19.8165 73.0695 29.1966 73.0981 40.7074C73.0981 46.5128 70.7531 51.9178 66.4919 55.9215C65.92 56.4649 65.5911 57.2227 65.5911 58.0092V79.4863C65.5911 80.3729 66.3061 81.0878 67.1926 81.0878C68.0791 81.0878 68.7941 80.3729 68.7941 79.4863V58.1522C73.6415 53.5479 76.3011 47.3564 76.3011 40.6931C76.2725 27.4093 65.4624 16.5849 52.1643 16.5706L52.1786 16.542Z" fill="#4B3F67" />
                  <path d="M45.0141 62.7998C45.0141 62.7998 44.9283 62.7998 44.8711 62.7998H32.5596C32.0877 62.7998 31.7017 63.1859 31.7017 63.6577C31.7017 64.1296 32.0877 64.5157 32.5596 64.5157H44.7281C45.6432 64.5157 46.4011 65.2592 46.4011 66.1887C46.4011 67.1181 45.6575 67.8617 44.7281 67.8617C43.7986 67.8617 43.0551 67.1181 43.0551 66.1887C43.0551 65.7168 42.669 65.3307 42.1972 65.3307C41.7253 65.3307 41.3392 65.7168 41.3392 66.1887C41.3392 68.0618 42.8549 69.5775 44.7281 69.5775C46.6013 69.5775 48.117 68.0618 48.117 66.1887C48.117 64.3155 46.7442 62.9571 44.9998 62.8141L45.0141 62.7998Z" fill="#4B3F67" />
                  <path d="M42.6833 56.3508H32.5596C32.0877 56.3508 31.7017 56.7369 31.7017 57.2087C31.7017 57.6806 32.0877 58.0667 32.5596 58.0667H42.8263C42.8263 58.0667 42.9121 58.0667 42.9693 58.0667C44.7138 57.9237 46.0865 56.4652 46.0865 54.6921C46.0865 52.8189 44.5708 51.3032 42.6976 51.3032C40.8244 51.3032 39.3087 52.8189 39.3087 54.6921C39.3087 55.164 39.6948 55.55 40.1667 55.55C40.6386 55.55 41.0246 55.164 41.0246 54.6921C41.0246 53.777 41.7682 53.0191 42.6976 53.0191C43.6271 53.0191 44.3706 53.7627 44.3706 54.6921C44.3706 55.6215 43.6271 56.3651 42.6976 56.3651L42.6833 56.3508Z" fill="#4B3F67" />
                </g>
                <defs>
                  <clipPath id="clip0_201_10052" onLoad={handleImageLoads}>
                    <rect width="59" height="66" fill="white" transform="translate(18 16)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className='inbrija-orally-inhaled-section-top-content'>
              <h3>INBRIJA is orally inhaled.</h3>
              <ul>
                <li className='show_desktop'>INBRIJA is inhaled levodopa, so it goes through your lungs and is absorbed faster than oral <br className='br-desktop' /> carbidopa/levodopa
                  <ul>
                    <li>Before using INBRIJA, tell your healthcare provider if you have asthma, chronic obstructive <br className='br-desktop' />pulmonary disease (COPD), or any chronic lung disease</li>
                    <li>Tell your healthcare provider if you experience bronchospasm. People with asthma, COPD,<br className='br-desktop' /> or other lung diseases may wheeze or have difficulty breathing after inhaling INBRIJA. If this<br className='br-desktop' /> occurs, stop taking INBRIJA and seek immediate medical attention</li>
                  </ul>
                </li>
                <li className='show_mobile'>INBRIJA is inhaled levodopa, so it goes through your lungs and is absorbed faster than oral carbidopa/levodopa
                  <ul>
                    <li>Before using INBRIJA, tell your healthcare provider if you have asthma, chronic obstructive<br className='br-desktop' /> pulmonary disease (COPD), or any chronic lung disease</li>
                    <li>Tell your healthcare provider if you experience bronchospasm. People with asthma, COPD,<br className='br-desktop' /> or other lung diseases may wheeze or have difficulty breathing after inhaling INBRIJA. If this <br className='br-desktop' />occurs, stop taking INBRIJA and seek immediate medical attention</li>
                  </ul>
                </li>
                <li>
                  INBRIJA is used in addition to your regular carbidopa/levodopa (CD/LD) medication. INBRIJA<br className='br-desktop' /> does <b>not replace</b> your regular CD/LD medicines. Use it when your regular PD medications<br className='br-desktop' /> aren't working as expected and your symptoms return
                </li>
                <li>Going through the lungs means that absorption of the medicine is not affected by meals or<br className='br-desktop' /> other conditions in your gut</li>
              </ul>
            </div>
          </div>
          
          <div className='inbrija-orally-inhaled-section-bottom'>
            <div className='inbrija-orally-inhaled-section-bottom-items'>
              <div className='inbrija-orally-inhaled-section-bottom-item'>
                <div className='inbrija-orally-inhaled-section-bottom-item-img' onLoad={handleImageLoads}>
                  <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <title>Inbrija inhaler</title>
                    <circle cx="55" cy="55" r="55" fill="white" />
                    <path d="M55.9916 112C25.1234 112 0 86.8766 0 55.9916C0 25.1066 25.1234 0 55.9916 0C86.8599 0 112 25.1234 112 55.9916C112 86.8599 86.8766 112 55.9916 112ZM55.9916 3.76851C27.2002 3.76851 3.76851 27.2002 3.76851 55.9916C3.76851 84.783 27.2002 108.231 55.9916 108.231C84.783 108.231 108.231 84.7998 108.231 55.9916C108.231 27.1835 84.7998 3.76851 55.9916 3.76851Z" fill="#634B7F" />
                    <path d="M54.618 45.3224C54.685 45.2051 54.7687 45.0544 54.8525 44.9204C54.1323 43.9824 53.3116 43.3125 52.5244 42.8435C51.3352 42.1233 50.1963 41.8218 49.5598 41.7046C49.4761 41.8386 49.3923 41.9726 49.3086 42.1066C49.9618 42.2238 51.2347 42.3745 52.4239 43.0947C53.2111 43.5805 53.8978 44.3844 54.618 45.3224Z" fill="#634B7F" />
                    <path d="M55.9246 39.946L53.6133 38.5391L53.0605 42.0563L55.9246 39.946Z" fill="#634B7F" />
                    <path d="M73.896 19.1103C73.762 18.8926 70.3955 13.8177 63.7294 12.93L63.5117 12.8965L63.3944 13.064C61.485 15.7773 58.353 20.1655 57.8673 20.668C57.5825 20.7685 57.0968 21.07 56.9628 21.1537L57.1471 21.4384L56.9293 21.1704C56.7786 21.2877 53.1441 24.202 42.944 39.1588C42.8602 39.2425 42.8268 39.3765 42.8268 39.5105C42.8435 39.7617 43.0445 40.0632 43.4465 40.4317L40.1637 45.8416L38.472 44.8199L38.2543 46.1263L37.5508 46.6958L37.4671 46.7795C32.8611 54.1993 25.5921 68.8379 25.5084 69.0053C19.2108 84.4144 23.7162 88.0154 24.5537 88.5346C24.6207 88.5681 24.6709 88.6016 24.6709 88.6016C34.7873 94.4302 55.1205 59.5087 55.9747 58.0181L56.0081 57.9176C56.0081 57.9176 56.1254 57.3314 56.2426 56.9629C56.2929 56.8121 56.5776 56.6614 56.7451 56.5944L57.4318 56.3432L55.3884 55.1038L58.6545 49.7274C59.1402 49.9283 59.5757 49.9953 59.8939 49.8278L59.9776 49.7776L60.0279 49.6939C60.3964 49.0239 68.9383 33.3804 69.4408 28.8749L69.6083 27.9538L73.9127 19.2611L73.8122 19.0936L73.896 19.1103ZM46.9302 54.7688L44.6189 53.3786L47.483 51.2682L46.9302 54.7855V54.7688ZM54.8692 54.7688L52.0889 53.0771C49.4761 48.3372 44.2002 47.8515 43.413 47.818L40.7834 46.2268L44.0327 40.8839C44.7529 41.3529 46.5953 42.4248 48.6051 42.6593C48.6219 42.6593 50.213 43.0278 51.4189 43.4633L48.0357 49.0406L49.0741 49.6771L52.4574 44.1165C52.9933 44.6022 53.8475 45.4396 54.5845 46.5116C55.1875 47.1145 56.6949 48.5884 58.0348 49.3924C58.0683 49.4091 58.1018 49.4259 58.1185 49.4426L54.886 54.7855L54.8692 54.7688ZM49.3086 42.1066C49.3923 41.9726 49.4761 41.8386 49.5598 41.7046C56.5274 30.3489 59.6929 30.2819 60.0279 30.3656C61.5855 32.409 57.1638 40.9677 54.8525 44.9204C54.7687 45.0544 54.685 45.2051 54.618 45.3224C53.8978 44.3844 53.2278 43.5805 52.4239 43.0948C51.2347 42.3746 49.945 42.2238 49.3086 42.1066ZM59.5422 49.2751C58.889 49.3924 56.7451 47.7342 55.087 46.0593C55.0702 46.0258 55.0535 46.0091 55.0367 45.9923L55.1875 45.7411C55.9914 44.4179 62.9925 32.6937 60.5136 29.8464L60.4299 29.7794C60.4299 29.7794 59.9944 29.5449 59.2574 29.7291C57.4988 30.1646 54.2663 32.5597 48.8396 41.5539L48.5716 41.9726C46.3273 41.6879 44.2504 40.2307 44.1164 40.1302C43.7312 39.812 43.5972 39.6278 43.547 39.544C52.2899 26.7478 56.2259 22.8118 57.1303 21.9576C57.9008 22.6611 60.5304 25.0897 62.021 26.8986L62.088 26.9823L62.2052 27.0158C62.2052 27.0158 66.6605 28.071 68.7708 29.0592C68.0841 33.5144 60.2959 47.8682 59.5254 49.2919L59.5422 49.2751ZM69.0388 27.7025L68.9216 28.3222C66.8782 27.401 63.2102 26.4966 62.49 26.3291C61.0161 24.5705 58.621 22.3429 57.7165 21.5222C57.9008 21.4217 58.0515 21.3379 58.1185 21.3212C58.2693 21.2877 58.487 21.2374 63.8299 13.6334C69.4073 14.4709 72.5728 18.4571 73.1925 19.3113L69.0388 27.6858V27.7025Z" fill="#634B7F" />
                    <path d="M99.9239 58.0515C98.1151 53.9145 90.2431 53.6968 77.1622 57.3983C67.5315 60.1116 58.3196 64.0643 57.5324 64.4161C57.3984 64.5333 57.0467 64.8515 56.7452 65.0525C56.5778 65.1698 56.36 65.22 56.1758 65.2368L56.7117 66.5432L58.1522 70.0605V70.1609C57.365 75.6043 61.7532 79.0211 61.8034 79.0546L61.8704 79.1049L63.2438 82.4379L63.7295 83.6271L64.1315 83.2418L65.2369 83.1916C73.3267 79.9591 87.7642 72.5225 87.915 72.4555C102.554 63.5284 99.9574 58.1352 99.9239 58.0682V58.0515ZM60.0615 74.3314L62.5906 71.8358L63.6123 74.3314H60.0615Z" fill="#634B7F" />
                  </svg>
                </div>
                <div className='inbrija-orally-inhaled-section-bottom-item-content'>
                  <h3>INBRIJA is for use as needed</h3>
                  <p>Take it as prescribed when your symptoms return (OFF periods). Use 1 dose (2 capsules) per OFF period and no more than 5 doses (10 capsules) per day.</p>
                </div>
              </div>
              <div className='inbrija-orally-inhaled-section-bottom-item'>
                <div className='inbrija-orally-inhaled-section-bottom-item-img center'>
                  <svg width="112" height="111" viewBox="0 0 112 111" fill="none" xmlns="http://www.w3.org/2000/svg" className='' onLoad={handleImageLoads}>
                    <title>Inbrija inhaler inside a shirt pocket</title>
                    <g clipPath="url(#clip0_206_10538)">
                      <path d="M65.2107 78.8721C65.9998 78.6305 66.4506 77.7771 66.193 76.9881C65.9515 76.199 65.098 75.7481 64.309 76.0058L60.7019 77.133C59.9129 77.3745 59.462 78.228 59.7196 79.017C59.9612 79.8061 60.8146 80.2569 61.6037 79.9993L65.2107 78.8721ZM59.9934 78.9365C59.8002 78.2924 60.1544 77.6161 60.7824 77.4067L64.3895 76.2795C65.0336 76.0863 65.7099 76.4406 65.9031 77.0686C66.0964 77.7127 65.7421 78.389 65.1141 78.5822L61.5071 79.7094C60.8629 79.9027 60.1866 79.5484 59.9934 78.9204V78.9365Z" fill="#634B7F" />
                      <path d="M61.2014 77.7446C61.2014 77.7446 61.1048 77.7929 61.0726 77.8251C60.7828 78.0023 60.6378 78.3565 60.7183 78.6947C60.7183 78.7108 60.7183 78.743 60.7183 78.7591C60.7183 78.7913 60.7505 78.8074 60.7666 78.8396C60.815 78.8235 60.8633 78.7913 60.8955 78.7591C60.8955 78.743 60.8633 78.7269 60.8633 78.6947C60.8633 78.6625 60.8633 78.6303 60.8633 78.5981C60.8311 78.3565 60.9277 78.115 61.1209 77.9701C61.1692 77.9379 61.2175 77.9057 61.2658 77.8896C61.2658 77.8735 61.2658 77.8413 61.2658 77.8251C61.2658 77.7929 61.2336 77.7768 61.2175 77.7446H61.2014Z" fill="#634B7F" />
                      <path d="M63.375 81.6899L63.4877 82.1086L64.9531 81.6899H63.375Z" fill="#634B7F" />
                      <path d="M10.1227 38.9529C10.2515 38.824 10.3804 38.6952 10.4931 38.5664C10.7668 38.2926 11.0245 38.0028 11.2821 37.729C11.411 37.5841 11.5398 37.4392 11.6686 37.2943C11.9101 37.0205 12.1517 36.7307 12.3932 36.4569C12.5059 36.3281 12.6026 36.1993 12.7153 36.0704C13.0051 35.7162 13.295 35.3619 13.5687 35.0077C13.6009 34.9755 13.617 34.9432 13.6493 34.911C13.8747 34.6051 13.9874 34.2669 13.9874 33.8805V28.7275C11.8135 32.3346 10.1066 36.151 8.8667 40.1445C8.8667 40.1445 8.8989 40.1284 8.8989 40.1123C9.33368 39.7258 9.73625 39.3232 10.1227 38.9368V38.9529Z" fill="white" />
                      <circle cx="55.5898" cy="55" r="55" fill="white" />
                      <path d="M69.2364 1.61029C68.6406 1.46536 68.0609 1.32044 67.4651 1.19161C66.8854 1.06279 66.2896 0.966173 65.6938 0.869555C62.4893 0.305955 59.2365 0 55.9837 0C38.8342 0 22.6186 8.03534 12.1517 21.5779L12.1034 21.5295L10.8796 23.2365L9.97782 24.4925L10.01 24.5247C6.06482 30.37 3.32733 36.8112 1.84587 43.671H1.81366L1.66874 44.4278C1.66874 44.4278 1.66874 44.4278 1.66874 44.4439L0.815284 48.679L1.02462 48.5502C0.750873 50.8207 0.589844 53.1073 0.589844 55.3939C0.589844 70.5306 6.59622 84.685 17.4979 95.2163C27.8842 105.265 41.5717 110.804 55.9998 110.804C70.428 110.804 84.1155 105.265 94.5018 95.2163C100.283 89.6286 104.743 82.8493 107.626 75.4259C108.318 73.6546 108.93 71.8671 109.429 70.0314C109.477 69.8543 109.51 69.661 109.558 69.4839C110.766 64.8785 111.394 60.1281 111.394 55.3778C111.394 29.9352 93.7772 7.61666 69.2364 1.57808V1.61029ZM15.2274 26.8113C15.2274 26.4087 15.1629 26.0222 15.0824 25.6358C15.0502 25.507 15.0019 25.3942 14.9697 25.2654C14.8892 25.0078 14.7926 24.7501 14.6799 24.4925C14.6477 24.4281 14.6316 24.3637 14.5993 24.2992C17.8038 20.032 21.6363 16.3444 25.8875 13.301C28.1097 14.3638 30.5895 14.9918 33.2304 14.9918C37.4493 14.9918 41.3301 13.462 44.3253 10.9339H29.5267C37.4493 6.21571 46.5636 3.60704 55.9998 3.60704C58.995 3.60704 61.9901 3.86469 64.9369 4.37998C64.9369 4.37998 64.9208 4.4605 64.9047 4.50881C64.6954 5.44277 64.4861 6.32843 64.2606 7.18188C64.2606 7.24629 64.2284 7.31071 64.2123 7.37512C63.9869 8.22857 63.7614 9.03371 63.536 9.80665C63.5038 9.90327 63.4716 9.99989 63.4555 10.0965C63.23 10.8533 62.9724 11.5619 62.7147 12.2704C62.6825 12.3831 62.6342 12.4797 62.602 12.5925C62.3444 13.2688 62.0706 13.929 61.7647 14.5731C61.7164 14.6697 61.6681 14.7824 61.6197 14.8791C61.3138 15.5071 60.9917 16.1351 60.6375 16.7309C60.5892 16.8275 60.5247 16.9241 60.4603 17.0207C60.09 17.6327 59.7035 18.2285 59.2687 18.8243C59.2043 18.9048 59.156 18.9853 59.0916 19.0658C58.6407 19.6777 58.1576 20.2735 57.6262 20.8854C57.5779 20.9337 57.5296 20.982 57.4813 21.0465C56.9177 21.6745 56.3219 22.3186 55.6456 22.9627C54.5989 23.9611 54.0031 25.362 54.0031 26.8113V33.8805C54.0031 35.056 54.3735 36.1671 55.0981 37.1171C55.1464 37.1654 55.1786 37.2299 55.2269 37.2782C49.4299 41.8997 33.0532 51.9157 14.5671 36.4569C14.7765 36.0865 14.9214 35.7001 15.0341 35.2814C15.0502 35.217 15.0663 35.1526 15.0824 35.0882C15.1791 34.6856 15.2435 34.283 15.2435 33.8643V26.7952L15.2274 26.8113ZM11.1855 35.0077C10.9118 35.3619 10.6219 35.7162 10.3321 36.0704C10.2355 36.1993 10.1227 36.3281 10.01 36.4569C9.78459 36.7307 9.54304 37.0205 9.2854 37.2943C9.15657 37.4392 9.02775 37.5841 8.89893 37.729C8.64128 38.0028 8.38364 38.2926 8.10989 38.5664C7.98106 38.6952 7.86834 38.824 7.73952 38.9529C7.35305 39.3393 6.95048 39.7419 6.5157 40.1284C6.5157 40.1284 6.4835 40.1445 6.4835 40.1606C7.70732 36.1671 9.43032 32.3507 11.6042 28.7436V33.8966M105.774 69.6771C103.294 78.3888 98.5275 86.3114 91.9737 92.656C82.2636 102.044 69.478 107.229 55.9837 107.229C42.4895 107.229 29.7038 102.06 19.9938 92.656C9.80069 82.801 4.19689 69.5805 4.19689 55.4261C4.19689 52.2377 4.48674 49.0333 5.08255 45.8932C5.25968 45.7805 5.42071 45.6517 5.58174 45.5389C5.83938 45.3618 6.09703 45.1686 6.33857 44.9914C6.59622 44.7982 6.82166 44.6211 7.0632 44.4278C7.30474 44.2346 7.54629 44.0414 7.77173 43.8481C7.98106 43.671 8.1904 43.4939 8.38364 43.3167C8.62518 43.1074 8.86672 42.8981 9.09216 42.6887C9.25319 42.5277 9.41422 42.3828 9.57525 42.2217C9.81679 41.9802 10.0583 41.7548 10.2999 41.5293C10.3321 41.4971 10.3643 41.4649 10.3965 41.4327C19.092 48.7273 27.4977 51.2394 34.9051 51.2394C46.2737 51.2394 55.2752 45.394 59.4459 42.0768C62.6342 45.1686 66.5633 47.8577 72.5375 50.4825C75.1945 51.6258 77.5777 52.7208 79.8643 53.7675C85.2427 56.2312 89.8964 58.3729 95.5968 60.0476C96.2087 60.2248 96.8045 60.4502 97.3681 60.6917C97.5614 60.7723 97.7385 60.885 97.9156 60.9655C98.286 61.1426 98.6725 61.3198 99.0267 61.5291C99.2361 61.6579 99.4293 61.8028 99.6386 61.9317C99.9446 62.141 100.267 62.3342 100.573 62.5597C100.782 62.7207 100.959 62.8978 101.168 63.0589C101.442 63.2843 101.716 63.5097 101.974 63.7513C102.167 63.9284 102.344 64.1378 102.521 64.331C102.763 64.5886 102.988 64.8302 103.213 65.0878C103.391 65.2972 103.536 65.5226 103.697 65.748C103.89 66.0218 104.099 66.2955 104.276 66.5693C104.421 66.8108 104.55 67.0524 104.695 67.2939C104.856 67.5838 105.017 67.8736 105.162 68.1796C105.291 68.4372 105.387 68.6949 105.484 68.9525C105.581 69.178 105.693 69.4034 105.774 69.6288V69.661V69.6771ZM107.03 64.1378C106.788 63.7835 106.531 63.4614 106.273 63.1233C106.225 63.0589 106.16 62.9784 106.112 62.8978C105.693 62.3664 105.226 61.8672 104.743 61.3842C104.614 61.2553 104.486 61.1426 104.357 61.0138C103.954 60.6434 103.552 60.2731 103.117 59.9349C102.988 59.8383 102.859 59.7256 102.73 59.629C102.183 59.2264 101.619 58.8399 101.023 58.4856C100.911 58.4212 100.782 58.3568 100.669 58.2924C100.17 58.0187 99.6547 57.761 99.1395 57.5195C98.9623 57.439 98.7852 57.3584 98.6081 57.294C97.9639 57.0203 97.3037 56.7787 96.6113 56.5694C91.1524 54.9591 86.6275 52.8818 81.3619 50.4664C79.0592 49.4036 76.6276 48.2925 73.9707 47.1492C65.6938 43.51 61.813 39.9029 57.9161 34.911C57.6906 34.6051 57.5779 34.2669 57.5779 33.8805V26.8113C57.5779 26.3443 57.7712 25.8934 58.1093 25.5714C58.528 25.1688 58.9306 24.7501 59.317 24.3475C59.4459 24.2187 59.5586 24.0738 59.6874 23.945C59.9289 23.6712 60.1866 23.4136 60.412 23.1398C60.557 22.9788 60.6697 22.8178 60.8146 22.6728C61.0239 22.4313 61.2333 22.1898 61.4265 21.9321C61.5553 21.755 61.6842 21.594 61.813 21.4168C61.9901 21.1753 62.1672 20.9498 62.3283 20.7083C62.4571 20.5312 62.5698 20.354 62.6986 20.1769C62.8597 19.9515 63.0046 19.7099 63.1656 19.4845C63.2783 19.3074 63.3911 19.1302 63.5038 18.9531C63.6487 18.7276 63.7775 18.4861 63.9225 18.2607C64.0191 18.0835 64.1318 17.9064 64.2284 17.7132C64.3572 17.4716 64.4861 17.2462 64.5988 17.0046C64.6954 16.8275 64.792 16.6343 64.8725 16.4571L65.4522 15.1689C65.565 14.9274 65.6616 14.6697 65.7582 14.4121C65.8387 14.2188 65.9031 14.0417 65.9836 13.8485C66.0802 13.5908 66.1769 13.3171 66.2735 13.0594C66.3379 12.8823 66.4023 12.6891 66.4667 12.5119C66.5633 12.2382 66.6438 11.9483 66.7405 11.6746C66.8049 11.4975 66.8532 11.3203 66.9176 11.1271C67.0142 10.8211 67.0947 10.5152 67.1913 10.1931C67.2397 10.0321 67.288 9.87106 67.3363 9.69393C67.4329 9.33967 67.5295 8.9693 67.6261 8.59894C67.6583 8.47011 67.6905 8.35739 67.7227 8.22857C67.9804 7.23019 68.2219 6.19961 68.4635 5.13682C91.3457 10.805 107.771 31.6583 107.771 55.41C107.771 58.3246 107.529 61.2392 107.03 64.1217V64.1378Z" fill="#634B7F" />
                      <path d="M79.9606 81.6414C81.748 78.3564 84.4211 71.8991 84.4372 71.8347C86.6755 64.7978 84.0024 63.5417 83.9702 63.5256C81.9896 62.5112 79.1393 64.5079 75.7416 69.2583C73.2457 72.7526 71.2811 76.6012 71.1201 76.9232C71.1201 77.0038 71.0879 77.2131 71.0557 77.358C71.0396 77.4385 70.9752 77.519 70.9108 77.5673L71.3456 77.7928L70.1217 80.176L68.6242 75.2807C68.3665 74.4595 67.819 73.7832 67.0622 73.3806C66.3054 72.978 65.4358 72.8975 64.6145 73.1391L59.0752 74.8299C58.2539 75.0875 57.5776 75.635 57.175 76.3918C56.7724 77.1487 56.6919 78.0182 56.9335 78.8395L57.7869 81.6575H55.9995V87.5994H84.6787V81.6575H79.9123L79.9767 81.6092L79.9606 81.6414ZM69.4615 81.4965L69.3649 81.6736H69.3971H64.9527L66.1121 81.3354L65.9833 80.9167L63.3746 81.6736H58.7692L57.8191 78.5818C57.642 78.0021 57.7064 77.3902 57.9963 76.8427C58.0607 76.73 58.1251 76.6173 58.2056 76.5207C58.4955 76.1503 58.8819 75.8765 59.3489 75.7316L64.8883 74.0408C65.468 73.8637 66.0799 73.9281 66.6274 74.218C67.1588 74.5078 67.5614 74.9748 67.7385 75.5545L69.0912 79.9989L66.4825 80.7557L66.6113 81.1744L69.22 80.4176L69.5098 81.3676L69.4615 81.4642V81.4965ZM75.323 78.2759L76.4985 78.9039L75.2425 79.8379L75.323 78.2759ZM70.5726 81.6897L70.2828 80.7557L71.6998 78.0021L73.1813 78.7912L73.2135 78.8234C74.7111 80.9812 77.3841 81.0456 77.4002 81.0456H77.4485L78.6402 81.6736H70.5887L70.5726 81.6897Z" fill="#634B7F" />
                    </g>
                    <defs>
                      <clipPath id="clip0_206_10538">
                        <rect width="110.82" height="110.82" fill="white" transform="translate(0.589844)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className='inbrija-orally-inhaled-section-bottom-item-content'>
                  <h3>INBRIJA is lightweight and portable</h3>
                  <p>INBRIJA is easy to carry with you. Store your INBRIJA at room temperature 68°F to 77°F (20 °C to 25 °C) in a dry place.</p>
                  <p>Keep the capsules in their foil (blister) packages until just before you're ready to use them.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='practice-banner-section' onLoad={handleImageLoads}>
          <div className='img-practice-banner'>
            <img className='img-fluid' src='/assets/images/practice-banner-mobile.webp' alt="" />
          </div>
          <div className="practice-banner-content">
            <h3 className="">
              Some practice and step-by-step instructions can help you get the hang of using your INBRIJA inhaler
            </h3>
            <p className="">
              99.8% of 629 people with Parkinson's in 2 clinical studies were able to <br className='br-desktop' /> use the inhaler after instruction during an OFF period.
            </p>
            <div className="show_desktop">
              <a className="practice-instruction-button" href="/how-to-use-inbrija" id='about_practice_how_to_use'>How to Use INBRIJA</a>
            </div>
            <div className="show_mobile text-center pb-3 pb-md-0">
              <a className='practice-instruction-button' href='/how-to-use-inbrija' id='about_practice_how_to_use'>How to Use INBRIJA</a>
            </div>
          </div>
        </div>

        <div className='copay-section' ref={TalkDr} id="talkDr">
          <div className='container-copay'>
            <div className='o-copay-section'>
              <img src="/assets/images/about-inbrija-msg.webp" alt='talk icon' onLoad={handleImageLoads} />
              <div className='o-copay-section-content'>
                <p>Talk to your doctor about a <b>$0 initial co-pay<sup>†</sup> for INBRIJA</b></p>
                <small><sup>&dagger;</sup>Limitations and restrictions apply.</small>
              </div>
            </div>
            <button onClick={() => navigate('/savings-and-support#savings-programs')}>See Savings Programs</button>
          </div>
        </div>
        <NavigationBar
          leftNavigation="Learn How to Use INBRIJA"
          rightNavigation="See More About Our Savings Program"
          leftNavigationid="about_learn_how_use"
          leftNavigationLink="/how-to-use-inbrija"
          rightNavigationLink="/savings-and-support"
          rightNavigationid="about_savings_program_footer"
        />
        <div ref={myRef}>
          <Isi />
        </div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}
        <Footer partNum="01/25 US-INB-2400111" title="Learn About INBRIJA® | INBRIJA® (levodopa inhalation powder)" />


        <AboutInbrijaModal show={startedModal} handleClose={() => { setStartedModal(false); setShowEle(false) }}>
          <div className='about-inbrija-ddg'>
            <div className={'ddg-email-modal'} id='step5-ddg-mobile'>
              <form onSubmit={handlePdfMobile}>
                <h1>Enter your email address</h1>
                {showEle ?
                  <p>We'll send the Doctor Discussion Guide straight to your inbox.</p> :
                  <p>We'll send the customized Doctor Discussion Guide straight to your inbox.</p>
                }
                <div className='center'>
                  <div className='input-field'>
                    <input placeholder='Email Address*' type='email' id='sendEmail' onChange={(e) => { ValidateInputEmail(); setEmail(e.target.value) }} />
                    <div className='required' id='sendEmailError'>*Required</div>
                  </div>
                </div>
                {showEle ?
                  <p>Have an upcoming doctor's appointment? Enter the date to receive an email with the guide ahead of your next visit.</p> :
                  <p>Have an upcoming doctor's appointment? Enter the date to receive an email with your customized guide ahead of your next visit.</p>
                }
                <div className='date-input'>
                  <input type='text' readOnly className='pointer' id="myDateInputinput" onClick={() => { MobileDatePicker(); handleQuesTracking('date', 'about_dynDDG_date') }} onChange={(e) => HandleChangeDate(e.target.value)} placeholder={`Date of Doctor's Appointment (Optional)`} />
                </div>
                <div className='content'>
                  <p>Acorda Therapeutics will use this information as part of its continuing efforts to develop products and services that meet the needs of healthcare professionals and patients. From time to time, Acorda may develop products, services, or educational services that may be of interest to you. By clicking submit, you are authorizing Acorda, its agents, or vendors acting on behalf of Acorda to:</p>
                  <ul>
                    <li>Send you information regarding Acorda and its products and services</li>
                    <li>Send you other important health, medical, or patient education information</li>
                    <li>Contact you to seek your participation in other surveys or programs</li>
                  </ul>
                  <p>View our <a href='http://www.acorda.com/privacy-policy' target='_blank' id='about_PP_footer' rel="noreferrer"><span>Privacy Policy</span></a>.</p>
                </div>
                <div className='email-buttons'>
                  <button className='back invisible'>Back</button>
                  <div className='bullets'>
                    <div className='bullet2'></div>
                    <div className='bullet2'></div>
                    <div className='bullet'></div>
                  </div>
                  <button className='email-next' type='submit' onClick={() => { GoTo('step5-ddg-mobile', 'step6-ddg-mobile'); }}>Submit</button>
                </div>
              </form>
            </div>

            <div className='inbox-modal d-none' id='step6-ddg-mobile'>
              <h1>Check your inbox</h1>
              {showEle ?
                <p>We've sent the Doctor Discussion Guide your way. You can also download it to your computer by clicking the button below.</p> :
                <p>We've sent the Doctor Discussion Guide your way. You can also download it to your computer<br /> or go back and change your answers.</p>}
              <div className='center'>
                <button target='_blank' onClick={getChromeVersion() > 60 ? handleDownloadBothApi : ''} className={boolDisableClick + " my-doctor-discussion-guide"} id='about_dynDDG_post_email_download'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5" stroke="#FEBA2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5.83331 8.3335L9.99998 12.5002L14.1666 8.3335" stroke="#FEBA2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M10 12.5V2.5" stroke="#FEBA2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  {showEle ? "Download the Guide" :
                    "Download My Doctor Discussion Guide"}</button>
              </div>

              <div className='a-padding'>
                {showEle ? '' :
                  <button id='about_dynDDG_post_email_restart' onClick={() => { GoTo('step6-ddg-mobile', 'step1-ddg'); setStartedModal(false); }}>Restart My Doctor Discussion Guide</button>
                }
              </div>


            </div>
          </div>
        </AboutInbrijaModal> 
      </div>
    </MainLayout>
  )
}